import request from '../utils/request';

export const getDomainInformation = ({ locale, domain }) => {
  return request(
    `/iwork/domain/getDomainInformation?lang=${locale}&domain=${domain}`
  );
};

export const saveDomainInformation = ({ locale, domain, type, value }) => {
  return request(
    `/iwork/domain/saveDomainInformation?lang=${locale}&domain=${domain}&type=${type}&value=${value}`
  );
};

export const getDefTempSettingLogoBg = ({ locale }) => {
  return request(
    `/smartmeeting/smart/third/getDefTempSettingLogoBg?lang=${locale}`
  );
};

export const saveDefTempSettingLogoBg = ({ locale, type, url }) => {
  return request(
    `/smartmeeting/smart/third/saveDefTempSettingLogoBg?lang=${locale}&type=${type}&url=${url}`
  );
};

export const getSmsSingName = ({ locale }) => {
  return request(`/iwork/domain/getSmsSingName?lang=${locale}`);
};

export const setSmsSingName = ({ locale, paramValue }) => {
  return request(
    `/iwork/domain/setSmsSingName?lang=${locale}&paramValue=${paramValue}`
  );
};

export const setSysName = ({locale,sysNameEN,sysNameZH}) => {
  return request(`/iwork/domain/setSysName?lang=${locale}&sysNameEN=${sysNameEN}&sysNameZH=${sysNameZH}`)
};

export const getSysName = ({locale}) => {
  return request(`/iwork/domain/getSysName?lang=${locale}`)
};



// WEBPACK FOOTER //
// ./src/services/personalization.js